// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oVlQe","right":"styles_right__3YUk7"};